module.exports = __webpack_public_path__ + "static/img/szafa_9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_9.svg
// module id = 6InN
// module chunks = 0